"use client";

import { Clock, MapPin } from "lucide-react";

export default function FooterInfo() {
  const serviceAreas = ["The Gold Coast"];

  return (
    <div className="space-y-8">
      {/* Opening Hours */}
      <div className="space-y-4">
        <h4 className="text-white text-lg font-bold font-body relative">
          Opening Hours
          <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[var(--color-rr-green)]"></div>
        </h4>
        <div className="space-y-2">
          <div className="flex items-start space-x-3">
            <Clock size={16} className="text-[var(--color-rr-green)] mt-1" />
            <div className="font-body space-y-1">
              <div className="text-gray-300 text-base">
                Mon – Fri: 7:00am – 5:00pm
              </div>
              <div className="text-gray-300 text-base">
                Sat: 7:00am – 12:00pm
              </div>
              <div className="text-gray-300 text-base">Sun: Closed</div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Areas */}
      <div className="space-y-4">
        <h4 className="text-white text-lg font-bold font-body relative">
          Service Areas
          <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[var(--color-rr-green)]"></div>
        </h4>
        <div className="space-y-2">
          {serviceAreas.map((area) => (
            <div key={area} className="flex items-center space-x-3">
              <MapPin size={16} className="text-[var(--color-rr-green)]" />
              <span className="text-gray-300 text-base font-body">{area}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
